export enum SleepRecorderType {
    recorderWithoutSmartphone = 'recorderWithoutSmartphone',
    recorderWithSmartphone = 'recorderWithSmartphone',
}
